import { render, staticRenderFns } from "./TokenPermissions.vue?vue&type=template&id=43b1563e&"
import script from "./TokenPermissions.vue?vue&type=script&lang=js&"
export * from "./TokenPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports